import React, { Component, Fragment } from 'react';
import { GET_LIST, Responsive, Title } from 'react-admin';
//import PendingReviews from './PendingReviews';
//import BuildsCard from './BuildsCard';
import SweepsCard from './SweepsCard';
import DocumentationCard from './DocumentationCard';
//import GroupsCard from './GroupsCard';
import jsonAWSProvider from '../cognito';
const dataProvider = jsonAWSProvider("MyAPIGatewayAPI");

const styles = {
    flex: { display: 'flex' },
    flexColumn: { display: 'flex', flexDirection: 'column' },
    leftCol: { flex: 1, marginRight: '1em' },
    rightCol: { flex: 1, marginLeft: '1em' },
    singleCol: { marginTop: '2em', marginBottom: '2em' },
};

class Dashboard extends Component {
    state = {};

    componentDidMount() {
        dataProvider(GET_LIST, 'customertest', {
            sort: { field: 'Created', order: 'DESC' },
            filter: { Dashboard: 'True'},
            pagination: { page: 1, perPage: 10 },
        })
            .then(response => response.data)
            .then(configs => {
                const nbConfigs = configs.reduce(nb => ++nb, 0);
                const Configs = configs.slice(
                    0,
                    Math.min(5, configs.length)
                );
                this.setState({ Configs, nbConfigs });
                return Configs;
            });
        dataProvider(GET_LIST, 'documentation', {
            sort: { field: 'Created', order: 'DESC' },
            filter: { dashboard: 'True'},
            pagination: { page: 1, perPage: 10 },
        })
            .then(response => response.data)
            .then(configs => {
                const nbMessages = configs.reduce(nb => ++nb, 0);
                const Messages = configs.slice(
                    0,
                    Math.min(5, configs.length)
                );
                this.setState({ Messages, nbMessages });
                return Messages;
            });
    }

    render() {
        const {
            nbConfigs,
            Configs,
            nbMessages,
            Messages
        } = this.state;
        return (
            <Fragment>
                <Title style={{ marginLeft: 16}} title="vDCM Cloud Test System" />
                <Responsive
                    medium={
                        <div style={styles.flex}>
                            <div style={styles.leftCol}>
                                <div style={styles.flex}>
                                    <DocumentationCard
                                        nb={nbMessages}
                                        reviews={Messages}
                                        customers={Messages}
                                    />
                                </div>
                            </div>
                            <div style={styles.rightCol}>
                                <div style={styles.flex}>
                                    <SweepsCard
                                        nb={nbConfigs}
                                        reviews={Configs}
                                        customers={Configs}
                                    />
                                </div>
                            </div>
                        </div>
                    }
                />
            </Fragment>
        );
    }
}

export default Dashboard;